export default class DigitalFashionPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.handleOffset();
  }

  handleOffset() {
    let offsetDOM = this.dom.querySelector(".offset");
    if (offsetDOM) {
      let keyEl = offsetDOM.querySelector("[js-offset-el]");
      offsetDOM.style.marginTop = `-${keyEl.offsetHeight / 2}px`;
    }
  }

  resize() {
    this.handleOffset;
  }
}
